module.exports = __webpack_public_path__ + "static/img/screan.72073da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/door/screan.png
// module id = msKx
// module chunks = 1